module.exports = __webpack_public_path__ + "eaadd5ea6b9b3b3a1a692cbd4edcedbb.svg";